import { fetchPage, postPage } from "@/services/config";
import type { TenantConfiguration } from "@/types/tenantManagement";

export interface PaymentSyncResponse {
  redirect_url: string;
}

const serviceBase = "cwacc";

export function fetchState<T = unknown>(tenantId: number): Promise<T> {
  return fetchPage<T>(serviceBase, `/user/fetch_state/tenant_id/${tenantId}`);
}

export function getTenantsOwnConfig(tenantId: number): Promise<TenantConfiguration> {
  return fetchPage<TenantConfiguration>(serviceBase, `/user/company_configurations/tenant_id/${tenantId}`);
}

export function getTenantConfigForAdmin(tenantId: number): Promise<TenantConfiguration> {
  return fetchPage<TenantConfiguration>(serviceBase, `/admin/companies/${tenantId}/configurations`);
}

export function resendEmailInvoice(
  tenantId: number,
  taskActionId: string
): Promise<{ status: number }> {
  return postPage<{ status: number }>(
    serviceBase,
    `/user/resend_email_invoice/tenant_id/${tenantId}/task_action_id/${taskActionId}`
  );
}

export function runPaymentSync(tenantId: number, configurationId: string, lastSyncDate: string): Promise<PaymentSyncResponse> {
  const formattedDate = lastSyncDate.replaceAll("-", "");
  return fetchPage<PaymentSyncResponse>(
    serviceBase,
    `/user/run_payment_sync/tenant_id/${tenantId}/configuration_id/${configurationId}/start_date/${formattedDate}`
  );
}
